<template>
    <div class="subscribe">
        <div class="subscribe__inner">
            <div class="flex">
                <div class="d6 md-7 sm-12 subscribe__col subscribe__col-left">
                    <div class="subscribe__col-inner">
                        <h2 class="subscribe__title">{{params.title}}</h2>
                        <div class="subscribe__desc">{{params.text}}</div>
                        <span class="result" :class="message.data.type">{{message.data.text}}</span>
                        <form :action="params.form.action" :method="params.form.method" class="subscribe__form flex v-center" @submit="formSubmit($event)">
                          <template v-for="field in form.fields">
                            <a-input
                                :name="field.name"
                                :type="field.type"
                                v-model="field.value"
                                :error="field.error"
                                :validator="(val) => form.processed&&field.name==='email' ? isEmail(val) : true"
                                :placeholder="params.messages.placeholder"
                                label=""
                                class="subscribe__input" v-if="field.type!='hidden'"/>
                            <input v-else :type="field.type" :name="field.name" v-model="field.value"/>
                          </template>
                            <a-btn :label="params.messages.btn" class="subscribe__btn secondary" />
                        </form>
                    </div>
                </div>
                <div class="d6 md-5 sm-12 subscribe__col subscribe__col-right" v-if="params.picture">
                    <div class="subscribe__col-inner">
                        <div class="subscribe__media">
                            <img :src="params.picture" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { reactive } from 'vue'
import { ABtn, AInput } from '../ui'
import { isEmail } from '../../libs/Validators'
import { useFormSend } from '../../composables'

export default {
    name: 'Subscribe',
    props: {
        params: {
            type: Object,
            default: () => {}
        }
    },
    components: {
        ABtn,
        AInput,
    },
    setup: (props, ctx) => {

        const form = reactive({
            processed: false,
            fields: props.params.form.fields
        })
        const message = reactive({data:props.params.message})
        const formSubmit = async (e) => {
            e.preventDefault()
            form.processed = true

            form.fields.email.error = !isEmail(form.fields.email.value)
            useFormSend(e, {
                url: props.params.form.action,
                method: props.params.form.method,
            }, form.fields, form).then(response => {
              message.data = response[props.params.responseKey].message;
            });

        }
        
        return {
            form,
            message,
            isEmail,
            formSubmit,
        }
    },
}
</script>

<style lang="scss">
  .result {
    margin-top: 23px;
    display: inline-block;

  }
  .result.error {
    color: #f00;
  }
  .result.ok {
    color: #21b601;
  }
    .subscribe {
        &__inner {
            background: var(--c-gray-700);
            @include mobile {
                > .flex {
                    flex-wrap: wrap;
                    flex-direction: column-reverse;
                }
            }
        }
        &__media {
            line-height: 1px;
            height: 100%;
            @include mobile {
                height: 200px;
            }
            img {
                object-fit: cover;
                width: 100%;
                height: 100%;
            }
        }
        &__col {
            @include mobile {
                width: 100%;
            }
            &-left {
                display: flex;
                justify-content: flex-end;

                .subscribe__col-inner {
                    max-width: 698px;
                    width: 100%;
                    padding: 0 72px 0 15px;
                    padding-top: 64px;
                    padding-bottom: 53px;

                    @include tablet {
                        padding: 0 32px 0 15px;
                        padding-top: 32px;
                        padding-bottom: 50px;
                    }
                    @include tablet {
                        padding: 40px 15px;
                        max-width: initial;
                    }
                }
            }
            &-inner {
                height: 100%;
            }
        }
        &__title {
            margin: 0;
            @include mobile {
                max-width: 180px;
            }
        }
        &__desc {
            font-family: var(--font-secondary);
            font-size: 18px;
            line-height: 28px;
            margin-top: 20px;

            @include tablet {
                font-size: 14px;
                line-height: 20px;
                margin-top: 4px;
            }
            @include mobile {
                margin-top: 14px;
                max-width: 200px;
            }
        }
        &__form {
            margin-top: 41px;




            @include tablet {
                margin-top: 24px;
            }
            @include mobile {
                margin-top: 20px;
                flex-wrap: wrap;
            }
        }
        .field {
            margin: 0;
            @include mobile {
                width: 100%;
            }
            &-content {
                &::before {
                    background: var(--c-gray-800);
                }
            }
            &.subscribe__input {
                flex: 1000 0 0;
                max-width: 460px;
                @include mobile {
                    max-width: initial;
                }
            }
            .input {
                font-size: 16px;
                &::placeholder {
                    font-size: 16px;
                    color: var(--c-gray-300);
                    @include tablet {
                        font-size: 14px;
                    }
                }
                @include tablet {
                    font-size: 14px;
                }
            }
        }
        &__btn {
            margin-left: 18px;
            min-width: 200px;

            @include tablet {
                min-width: 140px;
            }
            @include mobile {
                margin-left: 0;
                margin-top: 17px;
                width: 100%;
            }
        }
    }
</style>
